import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var Rectangle = function Rectangle(_a) {
  var width = _a.width,
    height = _a.height,
    rounded = _a.rounded,
    className = _a.className,
    rest = __rest(_a, ["width", "height", "rounded", "className"]);
  var style = {
    '--width': width,
    '--height': height
  };
  return jsx("div", Object.assign({
    className: classNames('cogs-v10', 'cogs-skeleton__rectangle', rounded && 'cogs-skeleton__rectangle--rounded', className),
    style: style
  }, rest));
};
var Circle = function Circle(_a) {
  var className = _a.className,
    diameter = _a.diameter,
    rest = __rest(_a, ["className", "diameter"]);
  var style = {
    '--diameter': diameter
  };
  return jsx("div", Object.assign({
    className: classNames('cogs-v10', 'cogs-skeleton__circle', className),
    style: style
  }, rest));
};

export { Circle, Rectangle };
